// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_ss_1B54ufTH","tab_wrap":"_ss_11h0Vt9V","tabs_header":"_ss_3lXnhiER","tabs_extra":"_ss_16amnUKc"};